module.exports = require('./lib/email-validation');



/*****************
 ** WEBPACK FOOTER
 ** ./~/email-validation/index.js
 ** module id = 230
 ** module chunks = 46 47
 **/